import React from "react";
import styles from "./donate.module.css";
import venmo from "../assets/venmo.jpeg";
import qr from "../assets/qrcode.svg";
import square from "../assets/square-logo-600x333.png";
import { FileDown } from 'lucide-react';

const Donate = () => {
    return (
        <div className={styles.hero}>
            <h1 className={styles.title}>Donate</h1>
            <p className={styles.subtitle}>Choose how you would like to donate.</p>
            <div className={styles.donation_div}>
                <a
                    href="https://www.venmo.com/u/WacoFirefightersBenefit"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.venmo_block}
                >
                    <img src={qr} alt="Venmo QR code" className={styles.venmo_qr} />
                    <img src={venmo} alt="Venmo" className={styles.venmo_badge} />
                </a>
                <a
                    href="https://checkout.square.site/merchant/ML8XRPDBMSGXT/checkout/3V7KFMEQYNSNU4VAUNXVW2QC"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img height="75" src={square} alt="Square checkout" />
                </a>
            </div>
            <div className="flex mx-auto w-full items-center flex-row text-blue-500 font-bold justify-center pb-16 underline">
            <a
                href="/WFBA Tax Deduction Form.pdf"
                download="WFBA Tax Deduction Form.pdf"
            >
                Download WFBA Tax Deduction Form 
            </a>
            <FileDown className="h-5 w-5"/>
            </div>
        </div>
    );
};

export default Donate;
